import React, { Fragment } from 'react'
import { IconS24Chair24 } from '@is24/cosma-ui-icons'
import { InsertionFlowScreensProps } from '../../../../../../@types/props-types'
import { SCREEN_WEB_VIEW_AMENITIES, SCREENS } from '../../../../../../services/domain/wizardScreens'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../@types/validation-types'
import ScreenContainer from '../../../../../common/containers/screenContainer/ScreenContainer'
import { FieldProps, TooltipTypes } from '../../../../../../@types/types'
import { ScreenLayout } from '../../../../../common/containers/screenLayout/ScreenLayout'
import { ScreenTooltip } from '../../../../../common/display/screenTooltip/ScreenTooltip'
import { isWebView } from '../../../../../../utils/navigation'

const screen = SCREENS[SCREEN_WEB_VIEW_AMENITIES]
export type WebViewAmenitiesWrapperProps = FieldProps<OtherFacilitiesScreenValidationResult>

export type WebViewAmenitiesAdditionalProps = {
  headerKey?: string
  screenTooltipKey?: string
  properties: ((webViewAmenitiesWrapperProps: WebViewAmenitiesWrapperProps) => JSX.Element)[]
}

const WebViewAmenities: React.FC<
  InsertionFlowScreensProps<OtherFacilitiesScreenValidationResult> & WebViewAmenitiesAdditionalProps
> = ({
  flowInformation,
  insertionData,
  validationMessages,
  properties,
  onChange,
  doReset,
  onNavigate,
  headerKey = 'wizard.screen.webViewAmenities.header',
  screenTooltipKey,
}) => {
  const isMobile = isWebView()

  const displayAppropriateTooltip = (tooltipType: TooltipTypes) => (
    <>{screenTooltipKey && <ScreenTooltip tooltipType={tooltipType} tooltipKey={screenTooltipKey} />}</>
  )

  const wrapperProps: WebViewAmenitiesWrapperProps = {
    flowInformation: flowInformation,
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    doReset: doReset,
    onChange: onChange,
  }
  return (
    <ScreenContainer
      className={isMobile ? 'margin-bottom-xxl' : ''}
      disableMarginBottom={isMobile}
      containerId={screen.id}
      onNavigate={onNavigate}
      screen={screen}
    >
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={headerKey}
        deskTooltip={displayAppropriateTooltip(TooltipTypes.DESKTOP)}
        mobileTooltip={displayAppropriateTooltip(TooltipTypes.MOBILE)}
        className='grid grid-flex gutter-vertical-l'
        headerIcon={<IconS24Chair24 />}
        screenName={screen.name}
      >
        {properties.map((item: (props: WebViewAmenitiesWrapperProps) => JSX.Element, index: number) => (
          <Fragment key={index}>{item(wrapperProps)}</Fragment>
        ))}
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default WebViewAmenities
